import type { ScheduleFormDataRule } from 'c-main/Components/Schedule/types';

/** A new rule. The schedule form starts it on the campaign's dates. */
export const emptyFormDataRule = (
    dateRange: ScheduleFormDataRule['date_range'] = [null, null],
): ScheduleFormDataRule => ({
    date_range: dateRange,
    days_of_week: [1, 2, 3, 4, 5, 6, 7],
    // days_of_week: {
    //     monday: true,
    //     tuesday: true,
    //     wednesday: true,
    //     thursday: true,
    //     friday: true,
    //     saturday: true,
    //     sunday: true,
    // },
    hours: [{ from: null, to: null }],
});
